import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Paginator } from "../../common/models/paginator";
import { castToModel } from "../../common/providers/utils-provider.service";
import { UrlFormatter } from '../../common/http/url-formatter';
import { User } from "../../common/models/user";
import { Organization } from "../../common/models/organization";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({
    providedIn: 'root'
})
export class ParticipantService {
    constructor(
        private apiService: ApiBaseService,
        private currentUser: CurrentUser,
    ) {
    }

    /**
     * Find all users for an organization
     *
     * @param currentUser
     * @param urlFormatter
     */
    public findAllByUserOrganizationsPaginated(currentUser: User, urlFormatter: UrlFormatter, organization: Organization): Observable<Paginator> {
        return this.apiService.call('get', urlFormatter.createUrl(`users/${currentUser.id}/chat/users/${organization.id}`), {}, this.currentUser.getAccessToken())
            .pipe(
                map((res: any) => Paginator.fromAPI(res))
            )
        ;
    }
}
